import { useSnackbar } from 'contexts/snackbar';
import { Button, Stack, Text } from 'shell/components';

const hourGlassSvg = (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M8.51953 15.5C8.51953 13.567 10.0865 12 12.0195 12C13.9525 12 15.5195 13.567 15.5195 15.5V19H8.51953V15.5Z'
            fill='#D3CCFF'
        />
        <path
            d='M16.5995 8.12V5.44H18.3195C18.4075 5.44 18.4795 5.368 18.4795 5.28V4.16C18.4795 4.072 18.4075 4 18.3195 4H5.67953C5.59153 4 5.51953 4.072 5.51953 4.16V5.28C5.51953 5.368 5.59153 5.44 5.67953 5.44H7.39953V8.12C7.39953 9.75 8.24753 11.184 9.52753 12C8.24753 12.816 7.39953 14.25 7.39953 15.88V18.56H5.67953C5.59153 18.56 5.51953 18.632 5.51953 18.72V19.84C5.51953 19.928 5.59153 20 5.67953 20H18.3195C18.4075 20 18.4795 19.928 18.4795 19.84V18.72C18.4795 18.632 18.4075 18.56 18.3195 18.56H16.5995V15.88C16.5995 14.25 15.7515 12.816 14.4715 12C15.7515 11.184 16.5995 9.75 16.5995 8.12ZM15.1595 15.88V18.56H8.83953V15.88C8.83953 15.036 9.16753 14.242 9.76553 13.646C10.3615 13.048 11.1555 12.72 11.9995 12.72C12.8435 12.72 13.6375 13.048 14.2335 13.646C14.8315 14.242 15.1595 15.036 15.1595 15.88ZM15.1595 8.12C15.1595 8.964 14.8315 9.758 14.2335 10.354C13.6375 10.952 12.8435 11.28 11.9995 11.28C11.1555 11.28 10.3615 10.952 9.76553 10.354C9.47085 10.0616 9.23723 9.71347 9.07827 9.32996C8.9193 8.94644 8.83815 8.53515 8.83953 8.12V5.44H15.1595V8.12Z'
            fill='#6347FF'
        />
    </svg>
);

const SnackbarDemo = () => {
    const { message } = useSnackbar();

    const handleClick = (type) => () => {
        switch (type) {
            case 'success':
                message.success('Enter success message here.');
                break;
            case 'warning':
                message.warning('Enter warning message here.');
                break;
            case 'error':
                message.error('Enter error message here.');
                break;
            case 'system':
                message.system(
                    <Stack alignItems={'flex-start'} spacing={3}>
                        <Stack alignItems={'center'} direction={'row'} spacing={2}>
                            {hourGlassSvg}
                            <Text variant={'p1'} weight={'semibold'}>
                                Your free trial ends in [X] days
                            </Text>
                        </Stack>
                        <Text>
                            Enjoying TimelyGrader’s paid features? Upgrade before [Y] to ensure there will be no
                            interruption to your account.
                        </Text>
                        <Button variant={'borderless'}>Upgrade</Button>
                    </Stack>
                );
                break;
            default:
                throw new Error();
        }
    };

    return (
        <>
            <Text variant={'sh1'}>Snackbar</Text>
            <Button onClick={handleClick('success')}>Open Success Notification</Button>
            <Button onClick={handleClick('warning')}>Open Warning Notification</Button>
            <Button onClick={handleClick('error')}>Open Error Notification</Button>
            <Button onClick={handleClick('system')}>Open System Notification</Button>
        </>
    );
};

export default SnackbarDemo;
